var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2566 4.50755H7.05659C5.37643 4.50755 4.53636 4.50755 3.89462 4.83453C3.33013 5.12215 2.87119 5.58109 2.58357 6.14558C2.25659 6.78732 2.25659 7.62739 2.25659 9.30755V17.7076C2.25659 19.3877 2.25659 20.2278 2.58357 20.8695C2.87119 21.434 3.33013 21.893 3.89462 22.1806C4.53636 22.5076 5.37643 22.5076 7.05659 22.5076H15.4566C17.1367 22.5076 17.9768 22.5076 18.6186 22.1806C19.1831 21.893 19.642 21.434 19.9296 20.8695C20.2566 20.2278 20.2566 19.3877 20.2566 17.7076V13.5076M8.25657 16.5076H9.93111C10.4203 16.5076 10.6649 16.5076 10.8951 16.4523C11.0991 16.4033 11.2942 16.3225 11.4732 16.2128C11.675 16.0891 11.8479 15.9162 12.1938 15.5703L21.7566 6.00755C22.585 5.17913 22.585 3.83598 21.7566 3.00755C20.9282 2.17912 19.585 2.17912 18.7566 3.00755L9.19383 12.5703C8.84792 12.9162 8.67497 13.0891 8.55129 13.291C8.44163 13.4699 8.36082 13.665 8.31183 13.8691C8.25656 14.0993 8.25657 14.3439 8.25657 14.833V16.5076Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.759e95f89ee6008b412111f069ae260a.svg";
export { ForwardRef as ReactComponent };